import PropTypes from 'prop-types';
import React from 'react';
import { GatewayDest } from 'react-gateway';
import WithShopName from '../hoc/WithShopName';
import Layout from './Layout';
import Title from './Title';
import Steps from './Steps';
import GiftCardLink from '../giftCard/GiftCardLink';
import Passcode from '../passcode';
import ThirdPartyPromotion from '../hoc/ThirdPartyPromotion';

const MainLayout = ({ children, urlPattern, shopName }) => (
  <Layout shopLayout>
    <Title>{shopName}</Title>
    <Steps urlPattern={urlPattern} />
    <GiftCardLink className="u-mt- medium-and-up-mt+ medium-and-down-mb" />
    <GatewayDest name="subtitle" className="u-show-for-large-and-up" />
    {children}
    <Passcode />
    <ThirdPartyPromotion />
  </Layout>
);

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  urlPattern: PropTypes.string,
  shopName: PropTypes.string,
};

MainLayout.defaultProps = {
  urlPattern: undefined,
  shopName: '',
};

export default WithShopName(MainLayout);



// WEBPACK FOOTER //
// ./src/app/components/ShopMainLayout.jsx